import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiBarChart } from 'react-icons/fi';

import { Container, TopWrapper, MenuWrapper } from './styles';

import { LeftSideBarContext } from '../index';

import BurgerButton from '../BurgerButton';

import { Pagina, BuscarSomentePaginas } from '../../../utils/apiTemp';

import api from '../../../services/api';

import { useAuth } from '../../../context/AuthContext';

const LeftSection: React.FC = () => {
  const { user } = useAuth();
  const { isShowSideBar, setIsShowSideBar } = useContext(LeftSideBarContext);
  const [paginas, setPaginas] = useState<Pagina[]>([]);

  useEffect(() => {
    if (user.empresa.url_frontend.toUpperCase() === 'EXEMPLO') {
      setPaginas(BuscarSomentePaginas);
    } else {
      api.get<Pagina[]>('/painel/paginas').then(response => {
        setPaginas(response.data);
      });
    }
  }, [user.empresa.url_frontend]);

  return (
    <Container isShow={isShowSideBar}>
      <TopWrapper>
        <BurgerButton onClick={() => setIsShowSideBar(false)} />
      </TopWrapper>
      <MenuWrapper>
        {paginas.map(item => (
          <li key={item.id}>
            <Link
              to={`/home/${item.id}`}
              onClick={() => setIsShowSideBar(false)}
            >
              <FiBarChart />
              {item.nome}
            </Link>
          </li>
        ))}
      </MenuWrapper>
    </Container>
  );
};

export default LeftSection;
